module.exports = __webpack_public_path__ + "static/media/twitter-black.834c1b32.svg";